export enum DeviceCategories {
  Drone = 'DRONE',
  Sensor = 'SENSOR',
  Camera = 'CAMERA',
  Controller = 'CONTROLLER',
  GroundStation = 'STATION',
  Other = 'OTHER'
}
